var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-btn"},[(_vm.type === 'bottom')?[_c('button',{staticClass:"btn hvr-pulse-shrink",style:({
        padding: 'unset',
        width: _vm.width,
        height: _vm.height,
        fontSize: _vm.fontSize,
        borderRadius: _vm.borderRadius,
        backgroundColor: _vm.backgroundColor,
      }),on:{"click":_vm.open}},[_vm._t("default",function(){return [_vm._v(" 立即沟通 ")]})],2)]:[_c('span',{staticClass:"btn-text",style:({ fontSize: _vm.fontSize }),on:{"click":_vm.open}},[_vm._t("default",function(){return [_vm._v(" 了解更多智能视频服务 → ")]})],2)],_c('Form',{model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }